import React from "react";
import Reveal from "../../components/Reveal";
import ChatshopHero from "../../components/cases/ChatshopHero";
import CaseArticleChatshop from "../../components/cases/CaseArticleChatshop";
import Footer from "../Footer";
import ContactCta from "../main_page/ContactCta";

export default function ChatshopCasePage() {
  return (
    <div className="case-detail-page">
      <Reveal as="section" variant="fade" threshold={0.15}>
        <ChatshopHero />
      </Reveal>

      <CaseArticleChatshop/>

      <Reveal as="section" variant="zoom" delay={0.08}>
        <ContactCta />
      </Reveal>

      <Footer />
    </div>
  );
}